import axios from "axios";
import firebase from "./firebase";

const publicRequest = async (method, path, data) => {
  const user = firebase.currentUser();
  const token = user && (await user.getIdToken());
  const baseURL = process.env.REACT_APP_API_HOST;

  return axios({
    method,
    baseURL,
    url: path,
    data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((response) => response.data);
};

export const initiateLoginMfa = ({ channel } = {}) =>
  publicRequest("post", "/public/login-mfa/initiate", channel ? { channel } : {});

export const resendLoginMfaCode = ({ channel } = {}) =>
  publicRequest("post", "/public/login-mfa/resend-code", channel ? { channel } : {});

export const verifyLoginMfaCode = ({ sessionId, code }) =>
  publicRequest("post", "/public/login-mfa/verify", { sessionId, code });

export const getLoginMfaStatus = () => publicRequest("get", "/public/login-mfa/status");

export const setupLoginMfaPhone = ({ phoneNumber }) =>
  publicRequest("post", "/public/login-mfa/setup-phone", { phoneNumber });

export const verifyLoginMfaPhoneSetup = ({ sessionId, code }) =>
  publicRequest("post", "/public/login-mfa/verify-phone-setup", { sessionId, code });
